var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.type * 1 === 2)?_c('div',[_c('img',{staticClass:"img",attrs:{"src":_vm.info},on:{"click":function($event){return _vm.clickImg(_vm.info)}}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }